"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable-next-line:export-name

exports.capitalizeFirstLetter = function (text) {
  return "" + text.substr(0, 1).toLocaleUpperCase() + text.substr(1).toLocaleLowerCase();
};